import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { MaterialListComponent } from './material-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  exports: [MaterialListComponent],
  declarations: [MaterialListComponent],
})
export class MaterialListModule { }
